import { render, staticRenderFns } from "./enveloperule.vue?vue&type=template&id=f20d56d0&scoped=true"
import script from "./enveloperule.vue?vue&type=script&lang=js"
export * from "./enveloperule.vue?vue&type=script&lang=js"
import style0 from "./enveloperule.vue?vue&type=style&index=0&id=f20d56d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20d56d0",
  null
  
)

export default component.exports